export default __webpack_public_path__ + "images/airport_checkin.81beac2.svg";